export { default as Img200 } from './processed/200/sons-of-anarchy.jpg';
export { default as Img400 } from './processed/400/sons-of-anarchy.jpg';
export { default as Imgthumb } from './processed/thumb/sons-of-anarchy.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/sons-of-anarchy.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/sons-of-anarchy.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      184,
      128,
      71
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      52,
      36,
      20
    ],
    "_population": 1,
    "_hsl": [
      0.08333333333333333,
      0.4444444444444444,
      0.1411764705882353
    ]
  },
  "Muted": {
    "_rgb": [
      109,
      127,
      135
    ],
    "_population": 2504,
    "_hsl": [
      0.5512820512820512,
      0.10655737704918036,
      0.4784313725490196
    ]
  },
  "LightMuted": {
    "_rgb": [
      186,
      177,
      166
    ],
    "_population": 2150,
    "_hsl": [
      0.09166666666666663,
      0.12658227848101258,
      0.6901960784313725
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      75,
      61
    ],
    "_population": 2277,
    "_hsl": [
      0.09722222222222225,
      0.16438356164383558,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/sons-of-anarchy.js